import React from 'react';

import PropTypes from 'prop-types';

import Row from './Row';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Table = ({ data, fetchOrders, totalOrders }) => {
  const {
    iotOrderDetailsSection: { orderFulfillmentDashboardHeaders }
  } = useLocalizedStringsContext();

  return (
    <div className="responsive-table-container">
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          Orders({totalOrders})
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            {orderFulfillmentDashboardHeaders.map(header => (
              <th>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {data &&
            data.map((order, index) => (
              <Row
                key={order.id}
                index={index}
                order={order}
                fetchOrders={fetchOrders}
                headers={orderFulfillmentDashboardHeaders}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  totalOrders: PropTypes.number.isRequired
};

export default Table;
